import { Button, FormattedMessageDiv } from '@odmonorepo/core-components';
import { useApplication } from 'merchant-api/unified';
import { getLDR } from 'merchant-api/spiceroad';
import { Stack, Card } from 'react-bootstrap';
import { FormattedMessage } from 'react-intl';

const LDRequest = () => {
  const { applicationData, isLoadingApplication } = useApplication();
  const { loanDocRequest, query } = getLDR();

  if (!loanDocRequest || query.status === 'pending' || !applicationData || isLoadingApplication) {
    return null;
  }
  let loanRequestType = '';
  if (loanDocRequest?.some((r) => r.status === 'REQUESTED' || r.status === 'REJECTED')) {
    loanRequestType = 'ldrRequest';
  } else if (loanDocRequest?.some((r) => r.status === 'MERCHANT_RESPONSE_SUBMITTED')) {
    loanRequestType = 'ldrPending';
  }

  return (
    <Stack gap={5} className="mx-auto" style={{ maxWidth: '600px' }}>
      <FormattedMessageDiv className="h3 text-center" id={`checkout.step.${loanRequestType}.heading`} />
      <Card className="p-5 p-sm-6">
        <FormattedMessageDiv className="h4" id={`checkout.step.${loanRequestType}.subheading`} values={{ renewal: applicationData?.type === 'RENEWAL' ? 'renewal' : '' }} />
        <FormattedMessageDiv id={`checkout.step.${loanRequestType}.message`} values={{ renewal: applicationData?.type === 'RENEWAL' ? 'renewal' : '' }} />
      </Card>
      <div className="text-center">
        {applicationData?.type === 'RENEWAL' && (
          <Button variant="link" className="fs-6 text-decoration-underline" href={'/'}>
            <FormattedMessage id="checkoutSuccess.button" />
          </Button>
        )}
      </div>
    </Stack>
  );
};

export default LDRequest;
